// ANCHOR React
import { ReactNode } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { LyonPage } from '@lyon/components/LyonPage';
import { SpacedDivider } from '@lyon/components/utils/Divider';
import { LyonFooter } from '@lyon/components/footer';
import { LyonProviderSidebar } from '../LyonProviderSidebar';

// ANCHOR Styles
import { CONTAINER, CONTENT, FOOTER } from './styles';

interface IProps {
  children: ReactNode;
}

export function LyonProviderContainer({ children }: IProps) {
  return (
    <LyonPage hideSidebar>
      <Block overrides={CONTAINER}>
        <LyonProviderSidebar />
        <Block overrides={CONTENT}>
          {children}
        </Block>
      </Block>
      <Block overrides={FOOTER}>
        <SpacedDivider top="192px" bottom="32px" />
        <LyonFooter />
      </Block>
    </LyonPage>
  );
}
